export enum CountryCode {
  KOR = 'KOR',
  ARG = 'ARG',
  AUS = 'AUS',
  AUT = 'AUT',
  BRA = 'BRA',
  KHM = 'KHM',
  CAN = 'CAN',
  CHL = 'CHL',
  CHN = 'CHN',
  HRV = 'HRV',
  DNK = 'DNK',
  ETH = 'ETH',
  FIN = 'FIN',
  FRA = 'FRA',
  DEU = 'DEU',
  GUM = 'GUM',
  GTM = 'GTM',
  HKG = 'HKG',
  IND = 'IND',
  IDN = 'IDN',
  IRL = 'IRL',
  ITA = 'ITA',
  JPN = 'JPN',
  KAZ = 'KAZ',
  KWT = 'KWT',
  KGZ = 'KGZ',
  MAC = 'MAC',
  MWI = 'MWI',
  MYS = 'MYS',
  MEX = 'MEX',
  NZL = 'NZL',
  PRK = 'PRK',
  NOR = 'NOR',
  PRY = 'PRY',
  PHL = 'PHL',
  PRT = 'PRT',
  RUS = 'RUS',
  SGP = 'SGP',
  ZAF = 'ZAF',
  ESP = 'ESP',
  SWE = 'SWE',
  CHE = 'CHE',
  TWN = 'TWN',
  THA = 'THA',
  UKR = 'UKR',
  GBR = 'GBR',
  USA = 'USA',
  UZB = 'UZB',
  VNM = 'VNM',
  ARE = 'ARE',
  AFG = 'AFG',
  ALB = 'ALB',
  ARM = 'ARM',
  AGO = 'AGO',
  ATA = 'ATA',
  ASM = 'ASM',
  ABW = 'ABW',
  BEL = 'BEL',
  BGR = 'BGR',
  BEN = 'BEN',
  BHS = 'BHS',
  DZA = 'DZA',
  GHA = 'GHA',
  SGS = 'SGS',
  HUN = 'HUN',
  ISR = 'ISR',
  IOT = 'IOT',
  LAO = 'LAO',
  MNG = 'MNG',
  MRT = 'MRT',
  NLD = 'NLD',
  PER = 'PER',
  POL = 'POL',
  SAU = 'SAU',
  SYC = 'SYC',
  SLV = 'SLV',
  TGO = 'TGO',
  TON = 'TON',
  UMI = 'UMI',
  VGB = 'VGB',
  ZWE = 'ZWE',
}
